export const getAprRangeText = function (paymentPlans) {
    if (!paymentPlans.length) return ""
    const aprs = paymentPlans.map(plan => plan.apr || 0)
    const min = Math.min(...aprs)
    const max = Math.max(...aprs)
    if (min === max) return `${min}%`
    return `${min}% - ${max}%`
}

export const getFinancedAmount = (fullyCovered, isUnderMinimum, financedAmountCents, paymentPlan) => {
    return fullyCovered ? financedAmountCents : isUnderMinimum ? paymentPlan.minAmountCents : paymentPlan.maxAmountCents
}
